import { Input } from 'antd';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Icon from '@ant-design/icons';
import { eyeIcon } from '@tools/ui/assets';
import { parseQuickAccessQuery } from '../../../utils/parse-quick-access-query';

export const QuickAccess: React.FC = () => {
  const history = useHistory();
  const [query, setQuery] = useState('');

  const parseQuery = (event: React.KeyboardEvent) => {
    if (event.code !== 'Enter') return;
    setQuery('');
    parseQuickAccessQuery(query, history);
  };

  return (
    <Input
      type="text"
      size="middle"
      autoFocus={true}
      style={{ width: 320 }}
      value={query}
      prefix={
        <Icon component={eyeIcon} style={{ marginRight: 4, marginTop: -1 }} />
      }
      onChange={(event) => setQuery(event.target.value)}
      onMouseDown={(event) => event.stopPropagation()}
      onKeyDown={parseQuery}
    />
  );
};
